import { canShowAverageAdvancedGroupPrice } from 'src/helpers';
import { Option, EnumPriceUnit } from 'src/types';
import useSearchBarState from 'src/hooks/useSearchBarState';
import Money from './Money';
import useCurrentCurrency from 'src/hooks/useCurrentCurrency';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

export const OptionCardPrice: React.FC<{
  option: Option;
  isGift?: boolean;
  textClass?: string;
  priceClass?: string;
  hiddenPriceUnit?: boolean;
}> = ({ option, isGift, textClass, hiddenPriceUnit }) => {
  const translation = useTranslations('components.OptionCardPrice')
  const className = textClass ? textClass : 'tw-font-normal tw-text-sm';
  const currentCurrency = useCurrentCurrency();
  const [searchBarParams] = useSearchBarState();
  const shouldShowDisplayAdvancedPrice =
    canShowAverageAdvancedGroupPrice(option) &&
    (searchBarParams.numGuest || 0) === 0;
  const minPrice = option.minPrice;

  return (
    <>
      {translation.rich('priceFrom', {
        from_text: (chunks: React.ReactNode) => (
          <span className={`${className} tw-text-brand-navy`}>{chunks}</span>
        ),
        money: (chunks: React.ReactNode) => (
          <>
            {minPrice['showDiscount?'] && minPrice.crossOutPrice && (
              <Money
                amount={minPrice.crossOutPrice.amount || minPrice.crossOutPrice.masterAmount}
                toCurrency={currentCurrency}
                className={`${className} tw-text-grey-light tw-line-through tw-mr-1`}
                decimalScale={0}
                hasConversionFee={!isGift && option.baseCurrency !== currentCurrency}
              />
            )}{' '}
            <Money
              amount={minPrice.price || minPrice.masterPrice}
              toCurrency={currentCurrency}
              decimalScale={0}
              hasConversionFee={!isGift && option.baseCurrency !== currentCurrency}
            />{' '}
          </>
        )
      })}
      <span
        className={classNames(`${className} tw-text-brand-navy`, { 'tw-hidden': hiddenPriceUnit })}
      >
        {shouldShowDisplayAdvancedPrice
          ? `/ ${translation('person')}`
          : option.priceUnit === EnumPriceUnit.perGroup
          ? option.yachtTrip
            ? `/ ${translation('yacht')}`
            : `/ ${translation('group')}`
          : `/ ${translation('person')}`}
      </span>
    </>
  );
};

export default OptionCardPrice;
